import React from 'react';

import { FooterSubcomponentProps } from '.';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Link,
  Typography,
} from '@mui/material';

import ContactInfoComponent from './ContactInfoSection';
import { getKeyFromLinkSection } from './utils';

const MobileFooter: React.FC<FooterSubcomponentProps> = ({
  linkSections,
  contactInfoSection,
  textColor,
  accentTextColor,
  isShowingCart,
}) => {
  const [expandedPanelIdx, setExpandedPanelIdx] = React.useState(-1);

  return (
    <Box
      sx={{
        padding: '1rem 2rem',
        marginBottom: isShowingCart ? '3rem' : undefined,
      }}
    >
      {linkSections.map((linkSection, idx) => {
        const isExpanded = idx === expandedPanelIdx;
        const { header, links } = linkSection;
        return (
          <Accordion
            disableGutters
            variant="elevation"
            elevation={0}
            expanded={isExpanded}
            onChange={() => {
              // close panel if already expanded
              setExpandedPanelIdx(isExpanded ? -1 : idx);
            }}
            key={getKeyFromLinkSection(linkSection, idx)}
            sx={{
              backgroundColor: 'rgba(0,0,0,0)', // make fully transparent to inherit parent background,
              // otherwise MUI is applying a darker shade.
              color: textColor,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                variant="h6"
                sx={{
                  color: isExpanded ? textColor : accentTextColor,
                }}
              >
                {header ?? 'Expand'}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {links?.map((link) => (
                <Link
                  key={`${link.url}-${link.displayText}`}
                  href={link.url}
                  target={link.target}
                  underline="hover"
                  color="inherit"
                >
                  <Typography
                    variant="caption"
                    component="div"
                    sx={{
                      color: 'inherit',
                      padding: '0.25rem 0',
                    }}
                  >
                    {link.displayText}
                  </Typography>
                </Link>
              ))}
            </AccordionDetails>
          </Accordion>
        );
      })}
      <ContactInfoComponent {...contactInfoSection} isSmallScreen />
    </Box>
  );
};

export default MobileFooter;
